/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Talk_Trainer_AskInputs */

const en_us2_plan_build_talk_trainer_ask = /** @type {(inputs: Plan_Build_Talk_Trainer_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I want to build my training plan with you, day by day. Where do we start?`)
};

const pt_br2_plan_build_talk_trainer_ask = /** @type {(inputs: Plan_Build_Talk_Trainer_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quero montar meu plano de treino com você, dia por dia. Por onde começamos?`)
};

const es_419_plan_build_talk_trainer_ask = /** @type {(inputs: Plan_Build_Talk_Trainer_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quiero armar mi plan de entrenamiento contigo, día por día. ¿Por dónde empezamos?`)
};

const pt_pt2_plan_build_talk_trainer_ask = /** @type {(inputs: Plan_Build_Talk_Trainer_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quero montar o meu plano de treino contigo, dia a dia. Por onde começamos?`)
};

const fr_fr2_plan_build_talk_trainer_ask = /** @type {(inputs: Plan_Build_Talk_Trainer_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je veux construire mon programme d'entraînement avec toi, jour par jour. On commence par où ?`)
};

const de_de2_plan_build_talk_trainer_ask = /** @type {(inputs: Plan_Build_Talk_Trainer_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich möchte meinen Trainingsplan mit dir aufbauen, Tag für Tag. Womit fangen wir an?`)
};

const it_it2_plan_build_talk_trainer_ask = /** @type {(inputs: Plan_Build_Talk_Trainer_AskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voglio creare la mia scheda di allenamento con te, giorno per giorno. Da dove iniziamo?`)
};

/**
* | output |
* | --- |
* | "I want to build my training plan with you, day by day. Where do we start?" |
*
* @param {Plan_Build_Talk_Trainer_AskInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_talk_trainer_ask = /** @type {((inputs?: Plan_Build_Talk_Trainer_AskInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Talk_Trainer_AskInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_talk_trainer_ask(inputs)
	if (locale === "es-419") return es_419_plan_build_talk_trainer_ask(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_talk_trainer_ask(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_talk_trainer_ask(inputs)
	if (locale === "de-DE") return de_de2_plan_build_talk_trainer_ask(inputs)
	if (locale === "it-IT") return it_it2_plan_build_talk_trainer_ask(inputs)
	return en_us2_plan_build_talk_trainer_ask(inputs)
});
export { plan_build_talk_trainer_ask as "plan-build.talk_trainer_ask" }